import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiTab = ({ palette, misc }: Pick<Tokens, 'palette' | 'misc'>) =>
  ({
    MuiTab: {
      defaultProps: {
        iconPosition: 'start',
      },
      styleOverrides: {
        root: {
          opacity: 1,
          color: palette.text.tertiary,
          fontWeight: 300,

          textTransform: 'none',

          ...misc.createFocusVisibleState({
            outline: misc.borderStyle('info.main', 3),
            outlineOffset: misc.borderSize(-3),
            borderRadius: misc.borderRadius(2),
            // move it above the indicator
            zIndex: 1,
          }),

          ...misc.createHoverOrActiveState({
            color: palette.dark.dark,
          }),

          height: spacing(6),
          minHeight: spacing(6),
          minWidth: spacing(11.25),
          maxWidth: spacing(45),
          padding: spacing(1, 2),

          '&.Mui-selected': {
            color: palette.dark.dark,
            fontWeight: 700,
          },

          '&.Mui-disabled': {
            color: palette.action.disabled,
          },
        },
      },
    },
  }) satisfies ComponentCreation
